import { connect } from 'react-redux'
import { isResponsiveModeEnabled } from '../../../redux/visualizer/selectors'
import { Navigation } from './Navigation.jsx'

const mapStateToProps = state => ({
    isResponsiveMode: isResponsiveModeEnabled(state)
})

export const NavigationContainer = connect(
    mapStateToProps,
)(Navigation)
